<template>
  <div>
    <slot name="top"></slot>
    <slot name="body" v-if="!enable || isShowingFilter"></slot>
    <slot name="footer"></slot>
    <div>
      <v-col class="flex-grow-1">
        <v-btn width="100%" @click="isShowingFilter = true" v-if="enable&&!isShowingFilter" color="primary">Показать
          все
        </v-btn>
        <v-btn width="100%" @click="isShowingFilter = false" v-if="enable&&isShowingFilter" color="primary">Скрыть
        </v-btn>
      </v-col>
    </div>
  </div>
</template>


<script>
export default {
  name: 'FilterTemplate',
  props: {
    enable: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isShowingFilter: false
    }
  }
}
</script>